import React, { FC } from "react";

export const BetMgmLogo: FC<Props> = ({ textColor = "#fff", height = 24 }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 201.8 54.5"
      style={{ height }}
    >
      <path
        className="st0"
        style={{
          fill: textColor,
        }}
        d="M81.9 32.3c0 3.7-2.7 5.8-8.2 5.8h-10V16.3h9.4c4.9 0 7.7 2.1 7.7 5.6 0 2.5-1.3 4.1-3.3 5 2.7.6 4.4 2.5 4.4 5.4zM66 18.2v7.9h6.9c3.5 0 5.5-1.3 5.5-4s-2-4-5.5-4H66zm13.6 13.9c0-2.8-2.1-4.1-5.9-4.1H66v8.2h7.7c3.8 0 5.9-1.2 5.9-4.1zM100.8 36.1v2H85.4V16.3h14.9v2H87.7v7.8H99v2H87.7v8.1h13.1zM110.5 18.3h-7.7v-2h17.6v2h-7.7v19.8h-2.3V18.3zM142.4 38.1l-.1-11.6-5.6 9.4H134l-5.6-9.1V38h-5.7V16.3h5.1l7.7 12.6 7.5-12.6h5.1l.1 21.8h-5.8zM167 26.8h5.4v9c-2.5 1.8-6 2.8-9.2 2.8-6.9 0-12-4.7-12-11.3 0-6.6 5.1-11.3 12.1-11.3 4.1 0 7.4 1.4 9.5 4l-3.9 3.5c-1.5-1.6-3.2-2.4-5.3-2.4-3.7 0-6.2 2.5-6.2 6.2s2.5 6.2 6.2 6.2c1.2 0 2.2-.2 3.3-.7v-6zM196.1 38.1l-.1-11.5-5.6 9.4h-2.7l-5.6-9.1v11.2h-5.7V16.3h5.1l7.7 12.6 7.5-12.6h5.1l.1 21.8h-5.8z"
      />
      <g>
        <path
          className="st1"
          style={{
            fill: "#c0a971",
          }}
          d="M2.8 22.4c0 4.8.8 9.3 3.2 13v-3.2c0-4 3.2-6.8 6.5-8.6-3.4 1.1-7.1.3-9.7-1.2M5.6 19H4.5c-.2-.6 1.5-1.7 2-.9l-.9.9zm-3.4-.5c.9.6 2.2.9 3.5.8 1.1.8 2.6-1.4 4.2-1.4 2.3-.3 5.2-.6 6.8 1.4l-.8-1.5c-2.2-.2-4-.9-5.7-1.9-3.4-1.5-5.1 3.4-8 2.6M.2 10.6c1.1.3 2.2.6 3.2.6 2.3-.9 2.9-2.8 2-5.2C4 4 2.2 2.9.2 2.5v8.1zM15.6 54.5c.3-.3.8-.8 1.1-1.2 6.2-8-5.9-12.7-5.6-20.4.3-3.1 2-5.4 4-7.9l-.1-.2c-1.9 1.9-2.6 3.1-3.9 4.9-3.7 7.6 1.5 18.1-3.9 24.5l8.4.3zM40.6 27.3c0 11.1-5.2 20.8-13.4 27.2h27.2V.2H27.2c8.1 6.1 13.4 16 13.4 27.1"
        />
        <path
          className="st1"
          style={{
            fill: "#c0a971",
          }}
          d="M.2 54.5h4.6l1.1-1.1c6.3-8.6-1.2-14.7-5.9-21.5l.2 22.6zM13 .2H.2v.9c1.2.2 2.6.6 3.7 1.1 2.6 1.5 4.6 4 4.3 7.1l5.7-.6c.8-1.9 1.1-4.8.3-6.3-.3-1-.8-1.8-1.2-2.2M15.6.2C16.8 1.9 16.8 4 17 5.7c2.3-1.7 5.1-2.8 8-2C23 2.2 21.6.9 19.1 0l-3.5.2zM27 27.8l-.5 1.2-.6-1.5c-1.4.3-2.8.8-3.5 2.3-.2.5.2 1.2-.3 1.5-.9-.2-.5-1.7-.5-2.6 1.1-1.1 4-3.4 5.1-2.5.3.2.5 1 .3 1.6m-6.2 11.1c-.8-.6-.5-1.7-.5-2.5l.5-.5c.8 2.5 2.8-.5 4.3-.2.8-.3.5-1.4 1.2-1.2 1.3 3.9-3.3 3.2-5.5 4.4m11.1.5c.6-5.1.2-10.5-3.5-14-.8-.2-1.9.3-2.5-.5-1.7 1.5-3.9 2.2-5.4 3.9-1.7.5-3.4-.6-5.1-.9v-.6c-2.3 1.5-1.7 4.6-2.2 6.9.6 2.6 3.5 3.7 5.4 5.2 2.9.5 5.6-.8 8-1.7.5.5 1.1.8.8 1.4-2 2.8-4.9 4-8.3 3.7 2 3.9.6 8.3-1.5 11.7h2c6.2-2.8 11.9-7.1 12.3-15.1"
        />
        <path
          className="st1"
          style={{
            fill: "#c0a971",
          }}
          d="M36.4 18.5c-1.7-5.9-6.9-13.7-13.9-13.3-2.6.2-5.2 2.2-6.2 3.7 1.9 1.1 3.9 2.6 5.6 4.2-.2.6.3 1.4-.5 1.7-.9-.8-1.7-2.6-2.9-2 .9 2 3.4 2.2 5.2 2.6.8.8.5 2 2 1.4.8.2 1.1 1.1 1.2 1.7-1.2 2.3-4.6.8-6.5 1.2 1.5.6 3.2.8 4.6 1.7 1.4.9 1.9-1.2 2.5-2 2.5.6 1.1 3.2 2.2 4.6 5.2 5.4 4.2 15 1.5 21.1 7.4-6.2 6.8-20.7 5.2-26.6"
        />
      </g>
    </svg>
  );
};

interface Props {
  textColor?: string;
  height?: number;
}
